import PaymentSetupCard from 'routes/PaymentSettings/PaymentSetupCard/PaymentSetupCard';

export default PaymentSetupCard;
